import request from "../../../util/request"
import { APP_KEY, PHP_API_URL } from "../../../util/constants";
import Cookies from 'js-cookie'
export function getCardInfoListRequest(cardCode, callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo',"get_erjicard_list");
    formData.append('yijicard_code', cardCode);
    formData.append('username', Cookies.get('username'));;
    
    return request(PHP_API_URL+"/AppCardCenter/i", {
        method: "POST",
        body: formData
    }, callback);
}

export function collectCardRequest(card_code, callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo',"shoucang_ai_card");
    formData.append('yingyong_type',"1");
    formData.append('card_code',card_code);
    formData.append('username', Cookies.get('username'));;
    
    return request(PHP_API_URL+"/index.php/User/i", {
        method: "POST",
        body: formData
    }, callback);
}
export function cancelCollectCardRequest(card_code, callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo',"quxiao_shoucang_ai_card");
    formData.append('card_code',card_code);
    formData.append('username', Cookies.get('username'));;
    
    return request(PHP_API_URL+"/index.php/User/i", {
        method: "POST",
        body: formData
    }, callback);
}

export function getVideoPlayerAuthRequest(VideoId, callback) {
    let formData = new FormData();
    // formData.append('caozuo', "xuexi_shiti");
    formData.append('VideoId', VideoId);
    return request(PHP_API_URL+"/aliyun/getplayauth.php", {
        method: "POST",
        body: formData
    }, callback);
}
export function getCommentInfoRequest(appCode,offset,limit, callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo', 'get_app_pingjia_list');
    formData.append('yingyong_type',"1");
    formData.append('app_code', appCode);
    formData.append('username', Cookies.get('username'));;
    formData.append('offset', offset);
    formData.append('limit', limit);
    return request(PHP_API_URL+"/AppCardCenter/i", {
        method: "POST",
        body: formData
    }, callback);
}
export function sendCommentRequest(appCode,appName,zhibiaoList,pingjia_content,callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo', 'add_app_pingjia');
    formData.append('yingyong_type',"1");
    formData.append('app_code', appCode);
    formData.append('app_name', appName);
    formData.append('username', Cookies.get('username'));;
    formData.append('zhibiao1_fenshu', zhibiaoList[0].fenshu);
    formData.append('zhibiao2_fenshu', zhibiaoList[1].fenshu);
    formData.append('zhibiao3_fenshu', zhibiaoList[2].fenshu);
    formData.append('zhibiao4_fenshu', zhibiaoList[3].fenshu);
    formData.append('pingjia_content', pingjia_content);
    return request(PHP_API_URL+"/AppCardCenter/i", {
        method: "POST",
        body: formData
    }, callback);
}

export function deleteCommentRequest(pingjiaId,appCode,zuixin_pingjia_status,callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo', 'del_app_pingjia');
    formData.append('pingjia_id', pingjiaId);
    formData.append('app_code', appCode);
    formData.append('username', Cookies.get('username'));;
    formData.append('zuixin_pingjia_status', zuixin_pingjia_status);
    formData.append('yingyong_type',"1");
    return request(PHP_API_URL+"/AppCardCenter/i", {
        method: "POST",
        body: formData
    }, callback);
}
export function updateAppLogRequest(paramers, callback) {
    let formData = new FormData();
    formData.append('yingyong_type',"2");
    formData.append('app_code', paramers.code);
    formData.append('app_name', paramers.title);
    formData.append('app_jifen', paramers.jifen);
    formData.append('username', Cookies.get('username'));;
    formData.append('user_type', Cookies.get("type"));
    formData.append('school_code', Cookies.get('school_code')=="null"?"":Cookies.get('school_code'));
    return request(PHP_API_URL+"/AppJiFei/app_userlog", {
        method: "POST",
        body: formData
    }, callback);
}